import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { DocumentoAllegato } from 'src/app/shared/models/documentoAllegato.model';
import { DocumentoRiproduzioneRow } from 'src/app/shared/models/documentoRiproduzione.model';

@Component({
  selector: 'app-allegati-riproduzione-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <p-dialog header="Gestione allegati" [(visible)]="visible" [modal]="true" (onHide)="hideDialog()" >
    @if (documentoRiproduzione(); as documentoRiproduzione) {
    <p-card>
      <p-messages key="allegati"></p-messages>
      <div class="grid">
        <div class="col-3">Numero richiesta: <b>{{documentoRiproduzione.numeroRichiesta}}</b> </div>
        <div class="col-3">Richiedente: <b>{{documentoRiproduzione.richiedente}}</b></div>
        <div class="col-3">Data richiesta: <b>{{documentoRiproduzione.dataRichiesta | date:'dd/MM/yyyy'}}</b></div>
      </div>
      @if (allegati(); as allegati) {
      <app-allegati [allegati]="allegati" [documentId]="documentoRiproduzione.documentoId" [isLocked]="false"
        [showHeader]="false" (deleteFile)="deleteDocumentoAllegato($event)"
        (changeRiproduzione)="changeRiproduzioneAllegato($event)" (showPassword)="showPasswordAllegato($event)">
      </app-allegati>
      }
    </p-card>
    }
  </p-dialog>
  `,
  styles: [`
  :host ::ng-deep .p-dialog.p-component{
    width: 78vw;
  }
  `]
})

export class AllegatiRiproduzioneDialogComponent {
  visible = model.required<boolean>();
  allegati = input<DocumentoAllegato[] | undefined>([]);
  documentoRiproduzione = input<DocumentoRiproduzioneRow>();

  hide = output();
  deleteFile = output<DocumentoAllegato>();
  showPassword = output<DocumentoAllegato>();
  changeRiproduzione = output<DocumentoAllegato>();

  hideDialog(): void {
    this.hide.emit();
  }

  public deleteDocumentoAllegato(documentoAllegato: DocumentoAllegato): void {
    this.deleteFile.emit(documentoAllegato);
  }

  public changeRiproduzioneAllegato(documentoAllegato: DocumentoAllegato): void {
    this.changeRiproduzione.emit(documentoAllegato);
  }

  public showPasswordAllegato(documentoAllegato: DocumentoAllegato): void {
    this.showPassword.emit(documentoAllegato);
  }
}
